module.exports = __webpack_public_path__ + "img/m2g-logo-only.6763596b.png";